<template>
  <div>
    <div class="filter-row">
      <DatePicker v-model="params.date" type="month" placeholder="选择时间" style="width: 200px"></DatePicker>
      <Button type="success" icon="search" @click="fetchData">筛选</Button>
    </div>
    <div class="lists">
      <Row class="lists-head">
        <Col span="4">部门</Col>
        <Col span="20">
          <Row>
            <Col span="6">姓名</Col>
            <Col span="6">时间</Col>
            <Col span="6">状态</Col>
            <Col span="6">金额</Col>
          </Row>
        </Col>
      </Row>
      <Row class="lists-row" style="border:none;border-bottom:1px solid #eee;line-height:24px" v-if="total>0">
        <Col span="4">&nbsp;</Col>
        <Col span="20">
          <Row class="lists-row" style="border:none;padding:0">
            <Col span="18" style="text-align:right">待打款：￥{{ddk}} <span style="color:#999">+</span> 已打款：￥{{ydk}}&nbsp;&nbsp;<span style="color:#999">=</span> 总计：</Col>
            <Col span="6">￥<span style="color:#f00;font-size:16px">{{total}}</span></Col>
          </Row>
        </Col>
      </Row>
        <Row class="lists-row" v-for="(res,ind) in result" :key="ind">
          <Col span="4">{{res.name}}</Col>
          <template v-if="res.expense.length > 0">
            <Col span="20">
              <Row class="lists-row" v-for="item in res.expense" :key="item.id">
                <Col span="6">{{getJson(item.content).username}}</Col>
                <Col span="6">{{getJson(item.content).time | formatTime}}</Col>
                <Col span="6">{{item.roval_state | rovalState}}</Col>
                <Col span="6">￥{{getJson(item.content).salary_all}}</Col>
              </Row>
              <Row class="lists-row" style="border:none;background:#eee">
                <Col span="18" style="text-align:right">待打款：￥{{res.ddk}} + 已打款：￥{{res.ydk}}&nbsp;&nbsp;= 合计：</Col>
                <Col span="6">￥<span style="color:#f60">{{res.total}}</span></Col>
              </Row>
            </Col>
          </template>
          <template v-else>
            <Col><span style="color:#ccc">--本月暂无记录--</span></Col>
          </template>
        </Row>
        <!-- <Table ref="table" border stripe :columns="resultColumns" :data="result.expense"></Table> -->
        <!-- <div class="pager" v-if="result.to<result.total"><Page :current="result.current_page" page-size="30"  :total="result.total" @on-change="resultPageChange" simple></Page></div> -->

      <Row class="lists-row" style="border:none;line-height:24px" v-if="total>0">
        <Col span="4">&nbsp;</Col>
        <Col span="20">
          <Row class="lists-row" style="border:none;padding:0">
            <Col span="18" style="text-align:right">待打款：￥{{ddk}} <span style="color:#999">+</span> 已打款：￥{{ydk}}&nbsp;&nbsp;<span style="color:#999">=</span> 总计：</Col>
            <Col span="6">￥<span style="color:#f00;font-size:16px">{{total}}</span></Col>
          </Row>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import {fetch} from '../fetch/api'
import {formatTime} from '../util/filter'

export default {
  name: 'ApplyExpenseCount',
  props: {
  },
  data () {
    var date = new Date()
    var year = Number(date.getFullYear())
    var month = Number(date.getMonth())
    if (month === 0) {
      year = year - 1
      month = 1
    }

    return {
      total: 0,
      ddk: 0,
      ydk: 0,
      params: {
        date: year + '-' + month
      },
      result: []
    }
  },
  watch: {
  },
  filters: {
    rovalState (state) {
      let str = ['待审核', '进行中', '待打款', '已打款', '未通过']
      return state === 11 ? '--' : str[state]
    },
    formatTime (time) {
      // if (!time) return '--'
      let date = new Date(time)
      return formatTime(date, 'yyyy-MM-dd')
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    getJson (con) {
      return JSON.parse(con)
    },
    fetchData () {
      fetch(`console/applyExpenseCount/all`, {params: this.params}).then(res => {
        this.result = res
        this.setTotal()
      })
    },
    setTotal () {
      var totalAll = 0
      var ddk = 0
      var ydk = 0
      for (let k in this.result) {
        var total = 0
        var pendingMoney = 0
        var madeMoney = 0
        for (let i in this.result[k].expense) {
          let content = JSON.parse(this.result[k].expense[i].content)
          let state = this.result[k].expense[i].roval_state
          let money = Number(content.salary_all)
          if (state === 2) {
            pendingMoney += money
          } else {
            madeMoney += money
          }
          total += money
        }
        this.result[k].ddk = pendingMoney.toFixed(2)
        this.result[k].ydk = madeMoney.toFixed(2)
        this.result[k].total = total.toFixed(2)
        totalAll += total
        ddk += pendingMoney
        ydk += madeMoney
      }
      this.total = totalAll.toFixed(2)
      this.ddk = ddk.toFixed(2)
      this.ydk = ydk.toFixed(2)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .lists{border-top:1px solid #eee}
  .lists-head{background-color: #eee;padding:10px;}
  .lists-row{
    border-bottom: 1px solid #eee;
    padding:10px;
  }
  .lists-row .lists-row{padding:10px 0;}
</style>
